<template>
  <div class="hello">  
  

    <div style="background-color:#e5e5e5;padding:15px;text-align:center;">
        <h1>Avcom Manufacturing > Meet Our Products</h1>
      <h3>The home of all your baking ingredients</h3>
    </div>

    <div style="overflow:auto">
       <div class="menu">
   <router-link to = "/" class = "main-links" style ="  text-decoration: none;  "> Home</router-link>
    <router-link to = "/AboutUs" class = "main-links" style ="  text-decoration: none;  ">About Us</router-link>
    <router-link to = "/BakingIngredients" class = "main-links" style ="  text-decoration: none;  ">Our Baking Ingredients</router-link>
    <router-link to = "/ContactUs" class = "main-links" style ="  text-decoration: none;  ">Contact Us</router-link>
    </div>

    <div class="main">
    <h2>Our Various Baking Ingredients</h2>
    <p>We have various baking ingrediens in stock. Among the ones that we have is the list below.We deliver top of the range products. Our goal is to provide lasting customer value. Please try one and you will have tested the real new world of baking experience.</p>
    </div>

    <div class="right">
    <h2>Our Product Range</h2>
    <p>At Avcom we understand that variety is the spice of life. So our baking ingredients come in various types so that you choose what is special for you.</p>
    <p>We consider each client's special requirements and we know how best to serve them. Each new customer, each new taste. That is our motto</p>
    </div>
    <hr/>
   <div class = "our-baking-ingredients">
     <figure>
 <img class = "backing-ingredients-display" src ="../assets/baking-ingredients1.jpeg" />
  <figcaption>Our First Baking Ingredient</figcaption>
</figure>

      </div>
        <div class = "our-baking-ingredients" style = "float:right">
           <figure>
 <img class = "backing-ingredients-display" src ="../assets/baking-ingredients4.jpeg" />
  <figcaption>Our Second Baking Ingredient</figcaption>
</figure>
        </div>
        <div style="clear:both"></div>
        <hr/>
        <div class = "our-baking-ingredients">
           <figure>
 <img class = "backing-ingredients-display" src ="../assets/bakingIgredient9.jpeg" />
  <figcaption>Our Third Baking Ingredient</figcaption>
</figure>
           </div>
        <div class = "our-baking-ingredients" style = "float:right">
           <figure>
 <img class = "backing-ingredients-display" src ="../assets/bakingIngredient13.jpeg" />
  <figcaption>Our Fourth Baking Ingredient</figcaption>
</figure>
        </div>
        <div style="clear:both"></div>
        <hr/>

<div class = "our-baking-ingredients">
   <figure>
 <img class = "backing-ingredients-display" src ="../assets/bakingIngredient6.jpeg" />
  <figcaption>Our Fifth Baking Ingredient</figcaption>
</figure>
   </div>
        <div class = "our-baking-ingredients" style = "float:right">
           <figure>
 <img class = "backing-ingredients-display" src ="../assets/bakingIngredient7.jpeg" />
  <figcaption>Our Sixth Baking Ingredient</figcaption>
</figure>
        </div>
        <div style="clear:both"></div>
        <hr/>

<div class = "our-baking-ingredients">
   <figure>
 <img class = "backing-ingredients-display" src ="../assets/bakingIngredient12.jpeg" />
  <figcaption>Our Seventh Baking Ingredient</figcaption>
</figure>
   </div>
        <div class = "our-baking-ingredients" style = "float:right">
           <figure>
 <img class = "backing-ingredients-display" src ="../assets/bakingIngredient11.jpeg" />
  <figcaption>Our Eighth Baking Ingredient</figcaption>
</figure>
          </div>
        <div style="clear:both"></div>
        <hr/>


    <footer>
      <div style="background-color:#e5e5e5;text-align:center;padding:10px;margin-top:7px;">
        <p>OUR PHYSICAL ADDRESSES:</p>
        <p>92 Cameroon Street </p>
        <p>Harare </p>
        <p>White House Building First Floor </p>
        <p>Shop Number 10</p>
        <hr/>
       <p> 1557 Dzivarasekwa Extension</p>
       <p> Dzivarasekwa</p>
       <p> Harare</p>
       <h3> FOR WHATSAPP CHAT CLICK ANY ONE ICON BELOW:   </h3>
        <P><a href="https://api.whatsapp.com/send/?phone=%2B263719327994&text&app_absent=0"><img src ="../assets/whatsapp.png" width ="80px"/></a></P>
        <p>OR</p>
        
            <p><a href="https://api.whatsapp.com/send/?phone=%2B263777327994&text&app_absent=0"><img src ="../assets/whatsapp.png" width ="80px"/></a></P>
        <br/>
                <h3> FOLLOW US ON OUR FACEBOOK PAGE   </h3>
                        <br/>

        <a href="https://www.facebook.com/Avcom-manufacturing-pvt-ltd-101934582241773/"><img src="../assets/facebook.png" width="80"></a>         


    </div>
    <hr/>
   <div style="background-color:#e5e5e5;text-align:center;padding:10px;margin-top:7px;">&copy; LearAdlib.com 2021</div>
     </footer>
   </div>
   </div>
</template>

<script>
export default {
  name: 'Home',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

* {
  box-sizing: border-box;
}

.menu {
  float: left;
  width: 20%;
  text-align: center;
}
.main-links:hover{

background-color: black;
color:white;
}

.menu a {
  background-color: #e5e5e5;
  padding: 8px;
  margin-top: 7px;
  display: block;
  width: 100%;
  color: black;
}

.main {
  float: left;
  width: 60%;
  padding: 0 20px;
}

.right {
  background-color: #e5e5e5;
  float: left;
  width: 20%;
  padding: 15px;
  margin-top: 7px;
  text-align: center;
}
.hello{
   background-image: linear-gradient(olivedrab, purple);
  width: 100%;
  padding-bottom: 10px;
  padding-top: 5px;
  padding-left: 2px;
  padding-right: 2px
}
.our-baking-ingredients{
  width:45%;
  height: 400px;
  border: solid black;
  float: left;
  margin: 20px auto;
  border-radius: 12px;
  
}
.backing-ingredients-display{
   max-width:100%;
   height: auto;
        border:none;
        display:block;
  height: 350px;
   border: 1px #cccccc solid;
  padding: 4px;
  margin: auto;

}

.backing-ingredients-display:hover{
  opacity: 0.6;
 
}

figcaption {
  background-color: black;
  color: white;
  font-style: italic;
  padding: 2px;
  text-align: center;
}

@media only screen and (max-width: 620px) {
  /* For mobile phones: */
  .menu, .main, .right {
    width: 100%;
  }
}
</style>

